export default __webpack_public_path__ + "./images/pn.2a6af7a3.png";